module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [(_vm.quiz.state != 'published') ? _c('div', {
    staticClass: "note note-danger"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Avertissement")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.quiz.state == 'published') ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Félicitation")]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._l((_vm.quiz.groups), function(group) {
    return _c('a', {
      staticClass: "link_share",
      attrs: {
        "href": _vm.config.front_url + 'questionnaire/' + _vm.quiz.slug + '?group=' + group.slug,
        "target": "_blank"
      }
    }, [_c('h5', [_vm._v(_vm._s(_vm.config.front_url) + "questionnaire/" + _vm._s(_vm.quiz.slug) + "?group=" + _vm._s(group.slug))])])
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" Vous devez publier votre questionnarie pour obtenir le lien de partage de ce dernier. "), _c('br'), _vm._v("\n        Cliquer sur le bouton \"Publier\" situé en bas à droite.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" Votre questionnaire a bien été publié et est accessible à l'addresse suivante  : "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbf114b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/share_quiz.vue
// module id = 110
// module chunks = 0